<template>
  <v-container fluid class="d-flex flex-wrap justify-center">
    <v-card
      v-for="patient in patients"
      :key="patient.id"
      class="d-flex flex-column justify-center ma-5"
      @click="selectPatient(patient)"
      flat
    >
      <div class="img-container">
        <img
          v-if="!patient.profilePicture || !patient.profilePicture.blobUri"
          class="profile-picture"
          src="@/assets/images/nophoto.png"
        />
        <img
          v-else
          class="profile-picture"
          :src="patient.profilePicture.blobUri"
        />
      </div>
      <h3
        class="mt-3"
      >
        {{ patient.firstName }}
      </h3>
    </v-card>
  </v-container>
</template>

<script>
import {neoparentUsers} from "@/api";

export default {
  name: "neoparent-patientselector",
  props: [],
  data() {
    return {
      patients: this.$store.getters.user.patients
    };
  },
  methods: {
    selectPatient(patient) {
      console.log("patient", patient)
      neoparentUsers.selectPatient(patient.id)
        .then(() => {
          location.href = "/"
        })
    }
  },
  mounted() {
    //let user = this.$store.getters.user
    //user.patient = null
    //this.$store.commit('updateUser', user)
  },
};
</script>

<style scoped lang="scss">
.img-container{
  width: 200px;
  height: 200px;
}

.profile-picture {
  object-fit: cover;
  border-radius: 50%;
  height: 100%
}
</style>
